export const sortedObjects = <T extends { id: number | string }[]>(
  array: T,
  sortedIds: (number | string)[],
): T =>
  array.sort((a, b) => {
    const indexA = sortedIds.indexOf(a.id)
    const indexB = sortedIds.indexOf(b.id)

    if (indexA === -1 && indexB === -1) return 0
    if (indexA === -1) return 1
    if (indexB === -1) return -1

    return indexA - indexB
  })
